<img class="app-bg-image mobile-show w-100" style="max-width: 100%;" [src]="commonService.resource.image.menu_bg_mob" alt="">
<img class="mobile-hide menu-bg" [src]="commonService.resource.image.menu_bg_desk" alt="">
<div class="app-container">
    <div class="content-container" style="top: 80px">
        <div class="row m-0  d-flex justify-content-center">
            <img class="mobile-show" [src]="commonService.resource.image.outlive_chat" alt="Outlive logo" style="width: 210px;">
        </div>
        <div class="content-container-frame">
            <div class="row m-0">
                <div class="col-md-2 p-0"></div>
                <div class="col-md-3 p-0"></div>
                <div class="col-md-5 col-sm-12 p-0 menu-container">
                    <div class="mt-5 pt-4 text-center">
                        <ng-container *ngFor="let menu of menuList;let i=index">
                            <div class="menu-option" (click)="navigateToMenu(menu.routeUrl)" [ngClass]="{'border-0': i>= menuList.length-1}">{{ menu.option | translate}}</div>
                        </ng-container>
                    </div>
                </div>
                <div class="col-md-2 p-0"></div>
            </div>
        </div>
    </div>
</div>